import { BehaviorSubject } from 'rxjs';
import { ServiceRepairFinderFilter } from '../models/service-repair-finder-filter.model';
import * as i0 from "@angular/core";
/**
 * Shares the Service/Repair Finder filter state between the landing page, the results page, and the
 * filter-list component. Mirrors {@link FboFinderFiltersService} (a root-provided BehaviorSubject).
 */
var ServiceRepairFinderFiltersService = /** @class */ (function () {
    function ServiceRepairFinderFiltersService() {
        this.serviceRepairFinderFilterSubject$ = new BehaviorSubject(new ServiceRepairFinderFilter());
        this.serviceRepairFinderFilter = this.serviceRepairFinderFilterSubject$.asObservable();
    }
    ServiceRepairFinderFiltersService.prototype.updateServiceRepairFinderFilters = function (serviceRepairFinderFilter) {
        this.serviceRepairFinderFilterSubject$.next(serviceRepairFinderFilter);
    };
    ServiceRepairFinderFiltersService.ngInjectableDef = i0.defineInjectable({ factory: function ServiceRepairFinderFiltersService_Factory() { return new ServiceRepairFinderFiltersService(); }, token: ServiceRepairFinderFiltersService, providedIn: "root" });
    return ServiceRepairFinderFiltersService;
}());
export { ServiceRepairFinderFiltersService };
